/**
 * Configuración global de la aplicación Multi-Chain Wallet
 * Este archivo actúa como punto de entrada que integra todas las configuraciones modulares
 */

// Importar configuraciones modulares
import {
  appConfig,
  getAppVersion,
  getAppName,
  getApiBaseUrl,
  getAlchemyKey,
  getMonitoringInterval,
  getStorageKey,
  getSessionDuration,
  getMinPasswordLength,
  getInactivityTimeout,
  getAlwaysRequirePasswordForTx,
  isDevelopmentMode,
  getDevPrivateKey,
} from './app';

import {
  networks,
  getNetwork,
  getNetworkByChainId,
  getNetworkLogoUrl,
  getTokenLogoUrl,
  getAllNetworks,
  getCustomNetworks,
  saveCustomNetwork,
  removeCustomNetwork,
  OMDB_CHAIN_ID,
} from './networks';

import {
  ERC20_ABI,
  POPULAR_TOKENS,
  getPopularTokens,
  getERC20Abi,
} from './tokens';

/**
 * Objeto de configuración global que expone todas las funciones y valores
 */
const config = {
  // Valores de app.ts
  appVersion: appConfig.appVersion,
  appName: appConfig.appName,
  apiBaseUrl: appConfig.apiBaseUrl,
  alchemyKeys: appConfig.alchemyKeys,
  monitoringInterval: appConfig.monitoringInterval,
  storageKeys: appConfig.storageKeys,
  security: appConfig.security,

  // Valores de networks.ts
  networks,

  // Valores de tokens.ts
  erc20Abi: ERC20_ABI,
  popularTokens: POPULAR_TOKENS,

  // Funciones de app.ts
  getAppVersion,
  getAppName,
  getApiBaseUrl,
  getAlchemyKey,
  getMonitoringInterval,
  getStorageKey,
  getSessionDuration,
  getMinPasswordLength,
  getInactivityTimeout,
  getAlwaysRequirePasswordForTx,
  isDevelopmentMode,
  getDevPrivateKey,

  // Funciones de networks.ts
  getNetwork,
  getNetworkByChainId,
  getNetworkLogoUrl,
  getTokenLogoUrl,
  getAllNetworks,
  getCustomNetworks,
  saveCustomNetwork,
  removeCustomNetwork,
  omdbChainId: OMDB_CHAIN_ID,

  // Funciones de tokens.ts
  getPopularTokens,
  getERC20Abi,
};

export default config;

// Exportar también las funciones individuales para importación directa
export {
  // App config
  appConfig,
  getAppVersion,
  getAppName,
  getApiBaseUrl,
  getAlchemyKey,
  getMonitoringInterval,
  getStorageKey,
  getSessionDuration,
  getMinPasswordLength,
  getInactivityTimeout,
  getAlwaysRequirePasswordForTx,
  isDevelopmentMode,
  getDevPrivateKey,

  // Networks
  networks,
  getNetwork,
  getNetworkByChainId,
  getNetworkLogoUrl,
  getTokenLogoUrl,
  getAllNetworks,
  getCustomNetworks,
  saveCustomNetwork,
  removeCustomNetwork,
  OMDB_CHAIN_ID,

  // Tokens
  ERC20_ABI,
  POPULAR_TOKENS,
  getPopularTokens,
  getERC20Abi,
};
